/**
 * @file WmsFieldLabel.tsx
 * @description Подпись поля в складских формах (phase19.13 этап 0).
 *
 * Вынесено из страниц приёмки/списания, чтобы формы выглядели одинаково и
 * не дублировали разметку.
 *
 * phase19.24: подпись рисует `.label-editorial` (12px/600) — было 10px и
 * `font-bold`, что ломало и шкалу, и правило «капс только одним рецептом».
 * Класс, а не `SectionLabel`: внутри `<label>` допустим только phrasing-контент.
 */

import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface Props {
  label: string;
  children: ReactNode;
  /**
   * Классы подписи — только раскладка и видимость. Нужны панели сборки: на
   * телефоне поле скана стоит первым экраном, и подпись над ним лишняя
   * (`hidden lg:block`).
   *
   * Цвет здесь задавать нельзя: `.label-editorial` лежит в слое utilities
   * после классов Tailwind и молча перебивает `text-*` (находка ревью
   * phase19.24). Понадобится акцент — тон-модификатор
   * `.label-editorial-primary`, как в `SectionLabel`.
   */
  className?: string;
}

export function WmsFieldLabel({ label, children, className }: Props) {
  return (
    <label className="flex flex-col gap-1">
      <span className={cn("label-editorial", className)}>{label}</span>
      {children}
    </label>
  );
}
